/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Table } from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import TablePager from 'loracoms/TablePager';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Checkbox from 'loracoms/Checkbox';
import callAPI from '@/api/callAPI';
import styles from '../styles.scss';

const kOffset = 10;

const propTypes = {
  intl: intlShape.isRequired,
  nodes: PropTypes.array.isRequired,
  onChecked: PropTypes.func.isRequired,
  deleteNode: PropTypes.object.isRequired,
  resetComponent: PropTypes.any.isRequired,
};

class Electric extends React.Component {
  constructor(props) {
    super(props);
    // const list = _.slice(props.nodes, this.mark, kOffset);
    // this.mark += kOffset;

    this.state = {
      list: [],
      checked: [],
      mark: 0,
      more: false,
    };
    this.mark = 0;
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.pairs.create');
    this.allNodes = props.nodes;
    this.deleteNode = props.deleteNode;
    this.isChecked = this.isChecked.bind(this);
    this.onNextPage = this.onNextPage.bind(this);
    this.onPrevPage = this.onPrevPage.bind(this);
  }

  componentDidMount() {
    this.loadAddElectrictNodes();
  }

  componentWillReceiveProps({ nodes, deleteNode, resetComponent }) {
    if (!_.isEqual(nodes, this.props.nodes)) {
      this.allNodes = nodes;
    }
    if (!_.isEqual(deleteNode, this.deleteNode)) {
      this.deleteNode = deleteNode;
      this.resetChecked();
    }
    if (resetComponent !== this.props.resetComponent) {
      this.resetComponent();
    }
  }

  onNextPage() {
    // const list = _.slice(this.allNodes, this.mark, this.mark + kOffset);
    this.mark += kOffset;
    // const more = this.allNodes.length > this.mark;
    // this.setState({ list, mark: this.mark, more });
    this.loadAddElectrictNodes();
  }

  onPrevPage(m) {
    this.mark = m || 0;
    // const list = _.slice(this.allNodes, this.mark, this.mark + kOffset);
    // this.mark += kOffset;
    // const more = this.allNodes.length > this.mark;
    // this.setState({ list, mark: this.mark, more });
    this.loadAddElectrictNodes();
  }

  loadAddElectrictNodes() {
    callAPI({
      endpoint: '/tdmng/nodes',
      query: { pair: 'n', typ: '电参', limit: kOffset, mark: this.mark },
      method: 'GET',
    }).then((res) => {
      const { list, mark, more } = res;
      this.setState({ list, mark, more });
    }).catch(() => {});
  }

  isChecked(d) {
    const { checked } = this.state;
    return _.some(checked, { id: d.id });
  }

  toggleCheck(d) {
    let { checked } = this.state;
    if (this.isChecked(d)) {
      checked = _.filter(checked, c => c.id !== d.id);
    } else {
      checked = _.concat(checked, [d]);
    }
    this.props.onChecked(checked);
    this.setState({ checked });
  }

  resetChecked() {
    let { checked } = this.state;
    checked = _.filter(checked, c => c.id !== this.deleteNode.id);
    this.setState({ checked });
  }

  resetComponent() {
    this.mark = 0;
    this.setState({ checked: [], reset: new Date().valueOf() });
    this.loadAddElectrictNodes();
  }

  render() {
    const {
      mark,
      more,
      list,
      reset = 0,
    } = this.state;

    return (
      <div className={styles.auto}>
        <Table className="aisz-table-light" striped>
          <thead>
            <tr>
              <th />
              <th>{this.intlMsg.msg('name')}</th>
              <th>ID</th>
            </tr>
          </thead>
          <tbody>
            {_.map(list, (item) => {
              const memo = item.memo ? JSON.parse(item.memo) : {};
              const checked = this.isChecked(item);
              return (
                <tr key={item.id}>
                  <td>
                    <Checkbox
                      id={item.id}
                      disabled={checked}
                      checked={checked}
                      onChange={() => this.toggleCheck(item)}
                    />
                  </td>
                  <td>{memo.name}</td>
                  <td>{item.id}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <ShowIf if={list.length > 0}>
          <div className={styles.pager} style={{ marginBottom: '10px' }}>
            <TablePager
              status="success"
              mark={mark}
              more={more}
              reset={reset}
              onPrev={this.onPrevPage}
              onNext={this.onNextPage}
            />
          </div>
        </ShowIf>
      </div>
    );
  }
}

Electric.propTypes = propTypes;

export default injectIntl(Electric);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Pairs/Electric.jsx